import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import { PrivateRoute, NotFound } from '../public';
import { Permission } from '../../types/Auth';

import JobListContainer from './JobListContainer';
import JobDetailContainer from './JobDetailContainer';

const Job: React.FC = (): React.ReactElement => {
    const routeMatch = useRouteMatch();
    return (
        <Switch>
            <PrivateRoute
                exact
                path={routeMatch.path}
                comp={JobListContainer}
                perm={Permission.JOB_LIST_SECTION_VIEW}
            />
            <PrivateRoute
                path={`${routeMatch.path}/detail/:jobId`}
                comp={JobDetailContainer}
                perm={Permission.JOB_DETAIL_SECTION_VIEW}
            />
            <Route path="*" component={NotFound} />
        </Switch>
    );
};

export default Job;
